module.exports = __webpack_public_path__ + "static/img/products_BioFactory.685bbcc5.png";